var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "125", height: "237", viewBox: "0 0 125 237", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "mask",
      { id: "a", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "125", height: "237" },
      React.createElement("path", { d: "M.63 2.36L96.51.97c15.13-.22 27.44 11.26 27.5 25.64l.77 208.28L1.5 236.7.63 2.35z", fill: "#32B186" })
    ),
    React.createElement(
      "g",
      { opacity: ".2", fillRule: "evenodd", clipRule: "evenodd", fill: "#32B186", mask: "url(#a)" },
      React.createElement("path", { opacity: ".3", d: "M1.71 119.97L123.58.87l122.73 115.5-121.87 119.1L1.71 119.97z" }),
      React.createElement("path", { opacity: ".5", d: "M32.48 148.92l91.33-89.4 91.97 86.7-91.33 89.4-91.97-86.7z" }),
      React.createElement("path", { d: "M63.24 177.88l60.9-59.6 61.3 57.8-60.88 59.6-61.32-57.8z" })
    )
  );
});